import axios from "axios";

const API_URL = "http://localhost:5000/api";

const api = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
export const installationAPI = {
  getAll: () => api.get("/installations"),
  getMyRequests: () => api.get("/installations/my-requests"),

  create: (data) => api.post("/installations", data),
  getById: (id) => api.get(`/installations/${id}`),
  update: (id, data) => api.put(`/installations/${id}`, data),
  addNote: (id, note) => api.post(`/installations/${id}/notes`, note),
  getStats: () => api.get("/installations/stats/summary"),

  cancel: (id, data) => axios.put("/installations/${id}/cancel", data),
};
export const authAPI = {
  login: (email, password) => api.post("/auth/login", { email, password }),
  register: (userData) => api.post("/auth/register", userData),
  getProfile: () => api.get("/auth/profile"),
  updateProfile: (profileData) => api.put("/auth/profile", profileData),
  changePassword: (passwordData) =>
    api.put("/auth/change-password", passwordData),
};
export const customerAPI = {
  getAll: () => api.get("/customers"),
  getById: (id) => api.get(`/customers/${id}`),
  create: (customerData) => api.post("/customers", customerData),
  update: (id, customerData) => api.put(`/customers/${id}`, customerData),
  delete: (id) => api.delete(`/customers/${id}`),
  getTransactions: (id) => api.get(`/customers/${id}/transactions`),
};

export const transactionAPI = {
  getAll: () => api.get("/transactions"),
  create: (transactionData) => api.post("/transactions", transactionData),
};
